import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Glutathione.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const glutathioneFAQs = [
  {
    question: 'How does glutathione therapy work?',
    answer:
      'Glutathione is a powerful antioxidant that helps reduce melanin production, which can gradually even out skin tone and add brightness with consistent use.',
  },
  {
    question: 'How soon will I see results?',
    answer:
      'Most people start noticing a brighter, more even complexion after 4 to 6 sessions, though this can vary based on individual skin response.',
  },
  {
    question: 'Is glutathione treatment safe?',
    answer: 'Yes, when administered by trained professionals at recommended doses, glutathione therapy is considered a safe skin brightening option.',
  },
  {
    question: 'Do I need maintenance sessions?',
    answer: 'To sustain results over time, occasional maintenance sessions are usually recommended alongside good sun protection.',
  },
]

const Glutathione = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='glutathionehero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Glutathione
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Best Glutathione Treatment in Pitampura | Skin Brightening & Glow Treatment
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best glutathione treatment in Pitampura? Advanced skin brightening treatment in Pitampura
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>

        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Glutathione Treatment in Pitampura</h2>
              <p>
                Healthy, radiant skin is often associated with balanced pigmentation and a natural glow. However, factors such as pollution, sun
                exposure, stress, and aging can lead to dull skin, dark spots, and uneven complexion. Modern dermatology treatments offer effective
                solutions to restore skin brightness and improve overall skin health.
              </p>
              <p>
                If you are searching for the <span style={{ fontWeight: 'bold' }}>best glutathione treatment in Pitampura</span>, advanced aesthetic
                clinics provide skin brightening therapies designed to reduce pigmentation and promote a clearer, more even skin tone.
              </p>
              <p>
                Glutathione treatment is widely known for its antioxidant properties that help improve skin clarity, reduce oxidative stress, and
                enhance the skin&apos;s natural radiance.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>What is Glutathione Treatment?</h3>
              <p>
                Glutathione is a powerful antioxidant naturally produced by the body that helps protect cells from damage caused by free radicals. In
                aesthetic dermatology, glutathione is used as part of skin brightening treatments because it helps reduce melanin production and
                improve overall skin tone.
              </p>
              <p>This treatment is often used to address:</p>
              <ul>
                <li>Uneven skin tone</li>
                <li>Hyperpigmentation</li>
                <li>Dark spots and acne marks</li>
                <li>Dull or tired-looking skin</li>
              </ul>
              <p>By reducing oxidative stress and supporting cell repair, glutathione helps improve skin texture and clarity over time.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Glutathione Treatment</h3>
              <p>
                Choosing the <span>best glutathione treatment in Pitampura</span> can offer several benefits for skin health and appearance. Key
                benefits include:
              </p>
              <ul>
                <li>Brighter and more even skin tone</li>
                <li>Reduction in pigmentation and dark spots</li>
                <li>Improved skin glow and radiance</li>
                <li>Antioxidant protection against pollution and sun damage</li>
                <li>Support for collagen production and skin elasticity</li>
              </ul>
              <p>Glutathione also helps neutralize harmful free radicals that contribute to premature aging and skin damage.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Who Should Consider Glutathione Treatment?</h3>
              <p>Glutathione therapy may be recommended for individuals experiencing:</p>
              <ul>
                <li>Uneven or dull skin tone</li>
                <li>Sun damage or pigmentation</li>
                <li>Acne marks and dark spots</li>
                <li>Early signs of skin aging</li>
              </ul>
              <p>
                A consultation with a skin specialist helps determine whether glutathione therapy is suitable based on skin type and specific
                concerns.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Types of Glutathione Treatments</h3>
              <p>Glutathione can be used in different forms depending on the treatment plan.</p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Glutathione IV Therapy</span>
                <br />
                Administered through intravenous infusion to deliver antioxidants directly into the bloodstream.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Glutathione Injections</span>
                <br />
                Used in some aesthetic treatments to improve skin tone and reduce pigmentation.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>Glutathione Skincare Treatments</span>
                <br />
                Includes serums, facials, or combination therapies that enhance skin brightness.
              </p>

              <p>Each treatment option may be customized depending on the individual&apos;s skin condition and aesthetic goals.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Safety and Expert Consultation</h3>
              <p>
                While glutathione offers multiple skin benefits, it should always be administered under professional supervision. High doses or
                unregulated use, especially intravenous forms, may lead to side effects such as allergic reactions or other health issues.
              </p>
              <p>Consulting a qualified cosmetic specialist ensures that the treatment is performed safely and appropriately.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Get the Best Glutathione Treatment in Pitampura</h3>
              <p>
                If you want brighter and heatlhier skin, choosing the <span style={{ fontWeight: 'bold' }}>best glutathione in Pitampura</span> can
                help improve skin tone, reduce pigmentation, and restore a natural glow.
              </p>
              <p>
                Professional guidance ensures skin clinics provide advanced treatment tailored to individual skin concerns, helping patients achieve
                smoother, more radiant skin with safe and effective procedures
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb="Dr. Sweta Mishra oversees glutathione and skin brightening treatments at Sharva Clinique, tailoring each plan to the patient's skin type and goals."
              profileLink='/appoint'
            />

            <ServiceFAQ title='FAQs - Glutathione Treatment' faqs={glutathioneFAQs} />
          </div>

          <div className='asthmareview'>
            <p
              className=''
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>

            <div className='card1'>
              <p>“My skin looks brighter and more even after just a few sessions. Really happy with the results.”</p>
              <p> — Sara </p>
            </div>

            <div className='card2'>
              <p>“I noticed a healthy glow within weeks. The treatment was smooth and professionally handled.”</p>
              <p> — Rohini </p>
            </div>

            <div className='card3'>
              <p>“Dark spots have reduced visibly. My complexion feels clearer and refreshed.”</p>
              <p> — Kush</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Glutathione
